import { render } from "./ContactFieldIcon.vue?vue&type=template&id=1e646b10&scoped=true"
import script from "./ContactFieldIcon.vue?vue&type=script&lang=js"
export * from "./ContactFieldIcon.vue?vue&type=script&lang=js"

import "./ContactFieldIcon.vue?vue&type=style&index=0&id=1e646b10&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e646b10"]])

export default __exports__